import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the ElementsFoodcostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-elements-foodcost',
  templateUrl: 'elements-foodcost.html',
})
export class ElementsFoodcostPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  avg_foodcost = 0;
  result: any;
  result2: any;
  result3: any;
  result4: any;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'name', name: this.translate.instant('general-nombre') },
    { prop: 'price', name: this.translate.instant('general-precio') + ' (' + this.globals.currency_symbol + ')' },
    { prop: 'foodcost', name: this.translate.instant('general-foodcost') + ' (' + this.globals.currency_symbol + ')' },
    { prop: 'benefit', name: this.translate.instant('general-beneficio') + ' (' + this.globals.currency_symbol + ')' },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
  ) {
    this.getAnalyticsData();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/elements_foodcost_benefit', params, {})
      .subscribe(async response => {
        this.avg_foodcost = response['avg_foodcost'];

        this.result = Math.round((response['total_sales'] + Number.EPSILON) * 100) / 100;

        this.result2 = Math.round((response['total_foodcost'] + Number.EPSILON) * 100) / 100;
        this.result3 = Math.round(this.result2 / this.result * 100);
        this.result4 = 100 - this.result3;

        var rs_foodcost_pb1 = document.getElementById('rs_foodcost_pb1');
        if (rs_foodcost_pb1) {
          rs_foodcost_pb1.style.display = 'none';
          var rs_foodcost_pb1_1 = document.getElementById('rs_foodcost_pb1_1');
          var rs_foodcost_pb1_2 = document.getElementById('rs_foodcost_pb1_2');
          if (rs_foodcost_pb1_1 && rs_foodcost_pb1_2) {
            rs_foodcost_pb1_1.style.width = this.result4 + '%';
            rs_foodcost_pb1_2.style.width = this.result3 + '%';

            (document.getElementById('rs_foodcost_pb1_1') as HTMLInputElement).innerText = 'B ' + this.result4 + '%';
            (document.getElementById('rs_foodcost_pb1_2') as HTMLInputElement).innerText = 'F ' + this.result3 + '%';

            rs_foodcost_pb1.style.display = 'flex';
          }
        }

        //list
        this.rows = response['list'];
        this.temp = response['list'];
        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const params = new HttpParams()
      .set('data', JSON.stringify(this.rows))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({ 'Foodcost Avg': this.avg_foodcost + '%', 'Benefit': this.result4 + '%', 'Foodcost': this.result3 + '%' }));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/elements-foodcost/elements-foodcost.ts